import DateFunc from '@/lib/lyg/date_func';
import strFunc from '@/lib/lyg/string';
import MultyLineTextView from "@/pcomponents/common/crud/view/multy_line_text";
import TextAreaComponent from "@/pcomponents/common/crud/write/textarea";
import CommentPartArea from "@/pcomponents/common/content/comment/part_area";
import ImgFileWriteList from "@/pages/comp/basic/file/frame/img/write_list";
import { useRef, useEffect } from 'react';
import { month_prescribe_select_arr } from "@/pcomponents/common/content/edu/month_prescribe/data/default_data";
import SelectBoxBar from "@/pcomponents/common/crud/write/select_box_bar";
import DailyLastArea from "./daily_last";

function TdContentArea(props: any) {
  let myProps = {
    select_mcomp_data:{
      mcomp_seq: "",
      api_key: "",
      api_user_seq: "",
    },
    name: "",
    week_info: {},
    week_idx: 0,
    week_idx_row_num: 0,
    on_change_week_info: (inData: any) => { },
    is_view_mode: false,
    go_write_week_info_arr_by_default_row: (inData: any) => { },
    openFindPrescribePopup: (inData: any) => { },
    openFindCounselorePopup: (inData: any) => { },
    openWriteCounselPopup: (inData: any) => { },
    comment_list: [],
    refresh_comment: (inData: any) => { },
    last_daily_report_info: {},
    is_now_week: false,
    ...props
  };
  let select_mcomp_data= myProps.select_mcomp_data;
  let name = myProps.name;
  let week_info = myProps.week_info;
  let is_view_mode = myProps.is_view_mode;

  let row_pri_val = week_info["a_ymd"] + "," + week_info["a_seq"];
  let is_update = false;
  let comment_init_data = {
    writer_seq: week_info.a_writer_seq,
    writer_name: week_info.a_writer_name,
    par_id: "month_prescribe",
    par_seq: row_pri_val,
    par_locate: "",
    par_locate_name: "",
    s_start_date: DateFunc.get_date_format(new Date(week_info["a_reserve_date"]), "Y-01-01"),
    s_end_date: DateFunc.get_date_format(new Date(), "Y-12-31"),
  };
  if (!strFunc.is_empty(week_info["a_seq"])) {
    is_update = true;
    comment_init_data["s_start_date"] = week_info["a_reserve_date"];
  }

  const ImgFileWriteListRef = useRef<any>(null);
  let img_file_init_list_opt = {
    "s_start_date": DateFunc.get_date_format(new Date(week_info["a_reserve_date"]), "Y-01-01"),
    "s_par_id": "month_prescribe",
    "s_par_seq": row_pri_val,
    "s_sort1": "a_lack",
    "s_sort2": "",
    "s_sort3": "",
  };
  useEffect(() => {
    if (ImgFileWriteListRef.current) {
      ImgFileWriteListRef.current.set_init_data({
        listOpt: img_file_init_list_opt,
        info_arr: week_info.file_arr ? week_info.file_arr : [],
      });
    }
  }, [row_pri_val]);

  return (
    <div>
      {name == "a_progress_reason" &&
        <div>
          <div className="text-left pl-2" style={{ fontWeight: "bold" }}>1. 진도전략</div>
          <div className="text-left mt-1" style={{ minHeight: 20 }}>
            {is_view_mode ?
              <MultyLineTextView text={week_info.a_progress_reason}></MultyLineTextView>
              :
              <TextAreaComponent
                name={"a_progress_reason"}
                value={week_info.a_progress_reason}
                class_name={"row-input"}
                height={32}
                style={{ "width": "100%" }}
                onChange={(e: any) => {
                  myProps.on_change_week_info({
                    name: "a_progress_reason",
                    value: e.target.value,
                    week_idx: myProps.week_idx,
                    week_idx_row_num: myProps.week_idx_row_num,
                  });
                }}
                placeholder={"내용입력"}
              ></TextAreaComponent>
            }
          </div>
        </div>
      }
      {name == "a_progress" &&
        <div>
          <div className="text-left pl-2" style={{ fontWeight: "bold" }}>2. 현재 진도</div>
          <DailyLastArea
            last_daily_report={myProps.last_daily_report_info}
          ></DailyLastArea>
          {/* <div className="text-left mt-1" style={{ minHeight: 20 }}>
            {is_view_mode ?
              <MultyLineTextView text={week_info.a_progress}></MultyLineTextView>
              :
              <TextAreaComponent
                name={"a_progress"}
                value={week_info.a_progress}
                class_name={"row-input"}
                height={32}
                style={{ "width": "100%" }}
                onChange={(e: any) => {
                  myProps.on_change_week_info({
                    name: "a_progress",
                    value: e.target.value,
                    week_idx: myProps.week_idx,
                    week_idx_row_num: myProps.week_idx_row_num,
                  });
                }}
                placeholder={"내용입력"}
              ></TextAreaComponent>
            }
          </div> */}
        </div>
      }
      {name == "a_grow" &&
        <div>
          <div className="text-left pl-2" style={{ fontWeight: "bold" }}>
            3. 성장한 부분
            {is_view_mode == false &&
              <button className="btn-s btn-dark ml-1" onClick={() => {
                myProps.openFindPrescribePopup({
                  row_num: myProps.week_idx,
                });
              }}>찾기</button>
            }
          </div>
          <div className="text-left mt-1" style={{ minHeight: 20 }}>
            {is_view_mode ?
              <MultyLineTextView text={week_info.a_grow}></MultyLineTextView>
              :
              <TextAreaComponent
                name={"a_grow"}
                value={week_info.a_grow}
                class_name={"row-input"}
                height={32}
                style={{ "width": "100%" }}
                onChange={(e: any) => {
                  myProps.on_change_week_info({
                    name: "a_grow",
                    value: e.target.value,
                    week_idx: myProps.week_idx,
                    week_idx_row_num: myProps.week_idx_row_num,
                  });
                }}
                placeholder={"내용입력"}
              ></TextAreaComponent>
            }
          </div>
        </div>
      }
      {name == "a_lack" &&
        <div>
          <div className="text-left" >
            <span style={{ fontWeight: "bold", background: "#fff59c", paddingRight: 5 }} >4. 발견</span>
          </div>
          <div className="write_table_small">
            <table>
              <colgroup>
                <col width={"30%"}></col>
                <col width={"70%"}></col>
              </colgroup>
              <tbody>
                <tr>
                  <th>숙제 수행도</th>
                  <td className="text-left">
                    <SelectBoxBar
                      valueTextArr={month_prescribe_select_arr["a_homework_degree"]}
                      value={week_info.a_homework_degree}
                      name={"a_homework_degree"}
                      on_change={(inData: any) => {
                        if (is_view_mode == false) {
                          myProps.on_change_week_info({
                            name: inData.name,
                            value: inData.value,
                            week_idx: myProps.week_idx,
                            week_idx_row_num: myProps.week_idx_row_num,
                          });
                        }
                      }}
                      style_type={"wide"}
                    ></SelectBoxBar>
                  </td>
                </tr>
                <tr>
                  <th>이해점수</th>
                  <td className="text-left">
                    <SelectBoxBar
                      valueTextArr={month_prescribe_select_arr["a_understand_degree"]}
                      value={week_info.a_understand_degree}
                      name={"a_understand_degree"}
                      on_change={(inData: any) => {
                        if (is_view_mode == false) {
                          myProps.on_change_week_info({
                            name: inData.name,
                            value: inData.value,
                            week_idx: myProps.week_idx,
                            week_idx_row_num: myProps.week_idx_row_num,
                          });
                        }
                      }}
                      style_type={"wide"}
                    ></SelectBoxBar>
                  </td>
                </tr>
                <tr>
                  <th>일일메모</th>
                  <td className="text-left">
                    <MultyLineTextView text={myProps.last_daily_report_info?myProps.last_daily_report_info["a_memo"]:""}></MultyLineTextView>
                  </td>
                </tr>
                <tr>
                  <th>수업태도</th>
                  <td className="text-left">
                    <SelectBoxBar
                      valueTextArr={month_prescribe_select_arr["a_lesson_attitude"]}
                      value={week_info.a_lesson_attitude}
                      name={"a_lesson_attitude"}
                      on_change={(inData: any) => {
                        if (is_view_mode == false) {
                          myProps.on_change_week_info({
                            name: inData.name,
                            value: inData.value,
                            week_idx: myProps.week_idx,
                            week_idx_row_num: myProps.week_idx_row_num,
                          });
                        }
                      }}
                      style_type={"wide"}
                    ></SelectBoxBar>
                  </td>
                </tr>
                <tr>
                  <th>학습정서(감정)</th>
                  <td className="text-left">
                    {is_view_mode ?
                      <MultyLineTextView text={week_info.a_study_emotion}></MultyLineTextView>
                      :
                      <TextAreaComponent
                        name={"a_study_emotion"}
                        value={week_info.a_study_emotion}
                        class_name={"row-input"}
                        height={24}
                        style={{ "width": "100%" }}
                        onChange={(e: any) => {
                          myProps.on_change_week_info({
                            name: e.target.name,
                            value: e.target.value,
                            week_idx: myProps.week_idx,
                            week_idx_row_num: myProps.week_idx_row_num,
                          });
                        }}
                        placeholder={"학습정서"}
                      ></TextAreaComponent>
                    }
                  </td>
                </tr>
                <tr>
                  <th colSpan={2} >
                    <div className="text-left pl-2">
                      새로운 발견 (상황중심기술)
                    </div>
                  </th>
                </tr>
                <tr>
                  <td colSpan={2} className="text-left">
                    <div className="text-left mt-1" style={{ minHeight: 20 }}>
                      {is_view_mode ?
                        <MultyLineTextView text={week_info.a_lack}></MultyLineTextView>
                        :
                        <TextAreaComponent
                          name={"a_lack"}
                          value={week_info.a_lack}
                          class_name={"row-input"}
                          height={32}
                          style={{ "width": "100%" }}
                          onChange={(e: any) => {
                            myProps.on_change_week_info({
                              name: e.target.name,
                              value: e.target.value,
                              week_idx: myProps.week_idx,
                              week_idx_row_num: myProps.week_idx_row_num,
                            });
                          }}
                          placeholder={"내용입력"}
                        ></TextAreaComponent>
                      }
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          {is_update &&
            <div>
              <ImgFileWriteList
                ref={ImgFileWriteListRef}
                select_mcomp_data={select_mcomp_data}
                is_view={false}
                listOpt={img_file_init_list_opt}
                list_type={"file_list"}
                is_save_btn={true}
                is_select_save={true}
                is_show_down={false}
                info_arr={week_info.file_arr ? week_info.file_arr : []}
                is_init_list={true}
                list_wrap_style={{ width: "18vw" }}
              ></ImgFileWriteList>
            </div>
          }
          <div>
            {is_update &&
              <CommentPartArea
                select_mcomp_data={select_mcomp_data}
                info_arr={myProps.comment_list}
                list={myProps.refresh_comment}
                is_show_toggle={false}
                is_show_detail={true}
                is_send_write_push={true}
                title_str={"질문"}
                wrap_style={{ width: "100%" }}
                init_data={{
                  ...comment_init_data,
                  par_locate: "a_lack",
                  par_locate_name: "질문",
                }}
              ></CommentPartArea>
            }
          </div>
          {is_view_mode==false &&
          <div className="mt-1 text-center">
            <button className="btn-s btn-sky ml-1"
              onClick={() => {
                myProps.go_write_week_info_arr_by_default_row({
                  default_week_info: week_info
                });
              }}>저장</button>
          </div>
          }
        </div>
      }
      {name == "a_content" &&
        <div>
          <div className="text-left pl-2" style={{ position: "relative",lineHeight:"23px",fontSize:"14px",color:"#fff",background:"#515151" }}>
            5. 학습 처방
            <span style={{ position: "absolute", right: 5 }} title={week_info.a_is_success == "1" ? week_info.a_success_date : ""} >
              <label>
                <input type="checkbox" name="a_is_success" value="1"
                  className="ml-2 mr-1"
                  checked={week_info.a_is_success == "1"}
                  onChange={(e: any) => {
                    let change_val = "";
                    if (e.target.checked) {
                      change_val = "1";
                    }
                    if (is_view_mode == false) {
                      myProps.on_change_week_info({
                        name: "a_is_success",
                        value: change_val,
                        week_idx: myProps.week_idx,
                        week_idx_row_num: myProps.week_idx_row_num,
                      });
                    }
                  }}
                />
                완료
              </label>
              <label>
                <input type="checkbox" name="a_is_request_counsel" value="1"
                  className="ml-2 mr-1"
                  checked={week_info.a_is_request_counsel == "1"}
                  onChange={(e: any) => {
                    let change_val = "";
                    if (e.target.checked) {
                      change_val = "1";
                    }
                    if (is_view_mode == false) {
                      myProps.on_change_week_info({
                        name: "a_is_request_counsel",
                        value: change_val,
                        week_idx: myProps.week_idx,
                        week_idx_row_num: myProps.week_idx_row_num,
                      });
                    }
                  }}
                />
                상담요청
              </label>
              <span className="ml-1">
                {week_info.a_request_counselor &&
                  <span>
                    ({week_info.a_request_counselor})
                  </span>
                }
                {(week_info.a_request_counselor && is_view_mode == false) &&
                  <button className="btn-s btn-red ml-1" onClick={() => {
                    myProps.on_change_week_info({
                      name: "a_request_counselor_seq",
                      value: "",
                      week_idx: myProps.week_idx,
                      week_idx_row_num: myProps.week_idx_row_num,
                    });
                  }}>x</button>
                }
              </span>
              {is_view_mode == false &&
                <span>
                  <button className="btn-s btn-gray ml-1" onClick={() => {
                    myProps.openFindCounselorePopup({
                      row_num: myProps.week_idx,
                    });
                  }}>찾기</button>
                </span>
              }
            </span>
          </div>
          <div className="text-left mt-1" style={{ minHeight: 20 }}>
            {is_view_mode ?
              <MultyLineTextView
                text={week_info.a_content}
                style={{ color: "blue" }}></MultyLineTextView>
              :
              <TextAreaComponent
                name={"a_content"}
                value={week_info.a_content}
                class_name={"row-input"}
                height={32}
                style={{ color: "blue" }}
                onChange={(e: any) => {
                  myProps.on_change_week_info({
                    name: "a_content",
                    value: e.target.value,
                    week_idx: myProps.week_idx,
                    week_idx_row_num: myProps.week_idx_row_num,
                  });
                }}
                placeholder={"내용입력"}
              ></TextAreaComponent>
            }
          </div>
          {week_info.a_is_success == "1" &&
            <div>
              <div className="text-left" style={{ fontWeight: "bold", position: "relative" }}>
                <label>
                  <input type="checkbox" name="a_is_success_check" value="1"
                    className="ml-1 mr-1"
                    checked={week_info.a_is_success_check == "1"}
                    onChange={(e: any) => {
                      let change_val = "";
                      if (e.target.checked) {
                        change_val = "1";
                      }
                      if (is_view_mode == false) {
                        myProps.on_change_week_info({
                          name: "a_is_success_check",
                          value: change_val,
                          week_idx: myProps.week_idx,
                          week_idx_row_num: myProps.week_idx_row_num,
                        });
                      }
                    }}
                  />
                  완료확인
                </label>
                {week_info.a_is_success_check &&
                  <span className="ml-2" style={{ color: "#aaa" }}>{week_info.a_success_check_date}</span>
                }
                {week_info.a_is_request_counsel == "1" &&
                  <span style={{ position: "absolute", right: 0 }}>
                    <button className="btn-s btn-sky"
                      onClick={() => {
                        myProps.openWriteCounselPopup({
                          row_pri_val: row_pri_val,
                          row_data: week_info,
                        });
                      }}
                      style={{ background: strFunc.is_empty(week_info.a_request_counsel_seq) ? "gray" : "" }}>
                      상담{strFunc.is_empty(week_info.a_request_counsel_seq) ? "등록" : "수정"}
                    </button>
                  </span>
                }
              </div>
              <div className="text-left mt-1" style={{ minHeight: 20 }}>
                {is_view_mode ?
                  <MultyLineTextView text={week_info.a_success_check_msg}></MultyLineTextView>
                  :
                  <TextAreaComponent
                    name={"a_success_check_msg"}
                    value={week_info.a_success_check_msg}
                    class_name={"row-input"}
                    height={32}
                    style={{ "width": "100%" }}
                    onChange={(e: any) => {
                      myProps.on_change_week_info({
                        name: "a_success_check_msg",
                        value: e.target.value,
                        week_idx: myProps.week_idx,
                        week_idx_row_num: myProps.week_idx_row_num,
                      });
                    }}
                    placeholder={"내용입력"}
                  ></TextAreaComponent>
                }
              </div>
            </div>
          }

          <div>
            {is_update &&
              <CommentPartArea
                select_mcomp_data={select_mcomp_data}
                info_arr={myProps.comment_list}
                list={myProps.refresh_comment}
                is_show_toggle={false}
                is_show_detail={true}
                is_send_write_push={true}
                title_str={"질문"}
                wrap_style={{ width: "100%" }}
                init_data={{
                  ...comment_init_data,
                  par_locate: "a_content",
                  par_locate_name: "질문",
                }}
              ></CommentPartArea>
            }
          </div>
        </div>
      }
    </div>
  );
};
export default TdContentArea;